import Request from '@/jslib/dk-axios'

export const recommendList = (data) => {
  return Request({
    url: 'Recommend',
    method: 'GET',
    params: data,
  })
}

export const addRecommend = (data) => {
  return Request({
    url: 'Recommend',
    method: 'POST',
    data,
  })
}

export const editRecommend = (data) => {
  return Request({
    url: `Recommend/${data.uuid}`,
    method: 'PUT',
    data,
  })
}

export const delRecommend = (data) => {
  return Request({
    url: `Recommend/${data.uuid}`,
    method: 'DELETE',
    data,
  })
}

export const recommendDetail = (data) => {
  return Request({
    url: `Recommend/${data.uuid}`,
    method: 'GET',
    params: data,
  })
}



// WEBPACK FOOTER //
// ./src/api/home-recommend.js